module.exports = __webpack_public_path__ + "8e3ed0bbce57940ac7d9b4e5bcc4f945.png";